import _ from 'lodash';

const postHeightFn = _.debounce(() => {
  const body = document.body;
  const html = document.documentElement;

  const height = Math.max( 
    body.scrollHeight, 
    body.offsetHeight, 
    html.offsetHeight 
  );
  
  window.parent.postMessage({type: "iframeResize", height}, '*')
}, 50)

function postHeight() {
  let inIframe = false;

  try {
    inIframe = window.self !== window.top;
  } catch (e) {
    inIframe =  true;
  }

  if(inIframe) {
    postHeightFn();
  }
}

export default {
  postHeight
}